<template>
  <div class="bg2">
    <!-- <Header title="领券中心" background="#ffffff"></Header> -->
    <div class="lists">
      <div class="list" v-for="(item,index) in list">
        <div class="listLeft">
          <span>{{item.cutMoney}}</span>
          <span>元</span>
        </div>
        <div class="listRight flex-between">
          <div class="top">
            <h5>满{{item.fullMoney}}可用</h5>
            <p>{{item.endTimeAt}}前有效</p>
          </div>
          <div class="bottom">
            <span v-if="item.is_use==0" @click="clickReceive(item,index)">立即领取</span>
            <img v-if="item.is_use==1" src="../../assets/home/yiling@2x.png" alt="" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
		list:[],
		form: {
		  lastId: 0, // 必选 最新ID。首次传0，之后传接口返回的lastId
		  page: 1, // 必选 请求数据页码
		  condition: {
		    status: '', // 商品分类ID。若不指定分类则传0
		  }, // 必选 搜索条件
		},
	};
  },
  computed: {},
  methods: {
    getInfo(type) {
      this.$post({
        module: "User",
        interface: "6000",
        data: this.form,
      }).then((res) => {
		// this.list = res
		
		this.form.lastId = res.lastId;
		this.form.page++;
		this.finished = res.currentPage >= res.lastPage;
		this.list = this.list.concat(res.list);
		this.loading = false;
      });
    },
	// getCoupon(item){
	// 	this.$post({
	// 	  module: "User",
	// 	  interface: "6001",
	// 	  data: {
	// 		  couponId:id
	// 	  },
	// 	}).then((res) => {
	// 		this.$toast("领取成功");
	// 	    this.
	// 	});
	// },
	//领取优惠券
	clickReceive(item,index){//console.log(index,this.list[index].is_use,33)
		this.$post({
		  module: "User",
		  interface: "6001",
		  data: {
			  couponId:item.id
		  },
		}).then((res) => {
			this.$toast('领取成功')
			this.list[index].is_use=1
		});
	}
  },
  created(){
    this.getInfo();
  }
};
</script>

<style lang='less' scoped>
.lists {
  margin: 0 16px;
  .list {
    background-image: url("../../assets/home/yhq_blue_bg@2x.png");
    background-size: 100% 100%;
    height: 94px;
    width: 100%;
    display: flex;
    align-items: center;
    margin-top: 14px;
    .listLeft {
      flex: 1;
      color: #ffffff;
      text-align: center;
      span:nth-child(1) {
        font-size: 30px;
      }
      span:nth-child(2) {
        font-size: 12px;
      }
    }
    .listRight {
      font-size: 12px;
      flex: 2;

      .top {
        flex-direction: column;
        justify-content: space-between;
        h5 {
          font-size: 17px;
          margin-bottom: 20px;
        }
        p {
          color: #919398;
        }
      }
      .bottom {
        display: flex;
        span {
          width: 64px;
          height: 22px;
          background: #fd0212;
          color: #ffffff;
          border-radius: 14px;
          text-align: center;
          line-height: 22px;
        }
        img {
          width: 80px;
          height: 80px;
        }
      }
    }
  }
}
</style>
